export default __webpack_public_path__ + "static/media/07.25.24 Minutes of the Regular Meeting of the BOD.a024ce53.pdf";